export enum TableSpecialValues {
  Check = ":check:",
  Clear = ":clear:",
  Newline = ":newline:",
}
